import { wrapLazily } from "../lazy-loading/lazyWrapper";
export const routes = () => {
	return [
		{
			path: "/backoffice/store/activation",
			component: wrapLazily(() => import("sd_bo_ui/StoreActivationPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "storeActivation",
			},
		},
		{
			path: "/backoffice/search/synonyms",
			component: wrapLazily(() => import("sd_bo_ui/SynonymsManagementPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "synonymsManagement",
			},
		},
		{
			path: "/backoffice/search/synonyms/edit",
			component: wrapLazily(() => import("sd_bo_ui/SynonymEditingPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "synonymsManagementEdit",
			},
		},
		{
			path: "/backoffice/search/compare",
			component: wrapLazily(() => import("sd_bo_ui/SearchComparisonPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "searchComparison",
			},
		},
		{
			path: "/backoffice/category/images",
			component: wrapLazily(() => import("sd_bo_ui/CategoryConfigurationPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "categoryImagesSettings",
			},
		},
		{
			path: "/backoffice/category/images/choose/:CategoryId",
			component: wrapLazily(() => import("sd_bo_ui/CategoryImagesChoosingPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "categoryImagesChoosing",
			},
		},
	];
};
